import constate from 'constate';

import { useSound } from './use-sound';

export const [SoundProvider, useSoundContext] = constate(useSound);
